import { Skeleton } from "@/components/ui/skeleton";
import { useFormatter, useTranslations } from "next-intl";
import React from "react";

type Props = {
  count: number;
  isLoading: boolean;
};

const SearchCount: React.FC<Props> = ({ count, isLoading }) => {
  const t = useTranslations("search");
  const formatter = useFormatter();
  return (
    <div className="flex items-center justify-center lg:justify-start h-full">
      {isLoading ? (
        <Skeleton className="w-36 h-7" />
      ) : (
        <p className="text-sm md:text-base text-center md:text-start text-balance pl-2 md:pl-0">
          {t.rich("found-rentals", {
            count: formatter.number(count),
            b: (chunk) => <strong>{chunk}</strong>,
          })}
        </p>
      )}
    </div>
  );
};

export default SearchCount;
